import React from "react";
import "../Button.css";
function Button2(props) {
  return (
    <button class="raise">
      <img src={props.logo} /> {props.name}
    </button>
  );
}

export default Button2;
